export default __webpack_public_path__ + "static/media/help_lief.8fb44a9e.svg";